const DrupalOAuth = require("./DrupalOAuth");

module.exports = async function fetchAuthenticatedContent(
	authContext,
	jsonapi_endpoint,
	method = "GET",
	body = null,
	headers = null,
	extraParams = {}
) {
	let state, dispatch;
	if (Array.isArray(authContext)) {
		[state, dispatch] = authContext;
	} else {
		state = {};
		dispatch = authContext;
	}
	const auth = new DrupalOAuth(state);
	const content = await auth.drupalFetch(
		jsonapi_endpoint,
		method,
		body,
		headers,
		extraParams
	);
	if (content === false) {
		dispatch({
			type: "LOGOUT_USER",
		});
	} else if (content === null) {
		console.warn("fobidden request was made");
	}
	return content;
};
